import { DetailedServiceBookingData, OrderRequestData } from "../Domain/RemoteOrderRequests.types";
import { normalizeOrderRequestDetailData } from "./normalizeOrderRequestDetailData.function";

type ApplyServiceIdOptions = {
  finalizeEquipmentDefaults?: boolean;
};

export const applyServiceId = (
  data: DetailedServiceBookingData,
  listRow?: OrderRequestData | null,
  options?: ApplyServiceIdOptions
): DetailedServiceBookingData => {
  const normalized = normalizeOrderRequestDetailData(data, listRow, options);

  return {
    ...normalized,
    caterings: normalized.caterings.map(cat => ({ ...cat, serviceId: cat.id })),
    equipments: normalized.equipments.map(equip => ({ ...equip, serviceId: equip.id })),
    roomLayouts: normalized.roomLayouts.map(layout => ({ ...layout, serviceId: layout.id }))
  };
};
